import React from "react";

/* HELPERS | UTILS */
import { convertToRupiah } from "../../../utils"

interface userCurrencyType {
  currency: string;
  ratio: number;
  isFetch: boolean; 
}

type PaymentSummaryProps = {
  asking_price: number
  admin_fee: number
  shipping_fee: number
  discount: number
  totalAddOnProduct: number
  subsidy_price: number
  amountToBePaid: string
  isCashback: boolean
  userCurrency: userCurrencyType
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  asking_price,
  admin_fee,
  shipping_fee,
  discount,
  totalAddOnProduct,
  subsidy_price,
  amountToBePaid,
  isCashback,
  userCurrency
}): JSX.Element => {
  return (
    <div className="summary-description-wrapper">
      <div className="title summary-row">
        <p>Payment Summary</p>
      </div>
      <div className="product-price summary-row">
        <p>Product Price</p>
        <p>{userCurrency?.currency} {convertToRupiah(asking_price)}</p>
      </div>
      {
        admin_fee > 0 && (
          <div className="adm-fee summary-row">
            <p>Administration Fee</p>
            <p>{userCurrency?.currency} {convertToRupiah(admin_fee)}</p>
          </div>
        )
      }
      {
        shipping_fee > 0 && (
          <div className="shipping-fee summary-row">
            <p>Shipping &#38; Handling</p>
            <p>{userCurrency?.currency} {convertToRupiah(shipping_fee)}</p>
          </div>
        )
      }
      {
        discount > 0 && (
          <div className="discount summary-row">
            <p>{isCashback ? "Potential Cashback" : "Voucher Code"}</p>
            <p className={`${isCashback ? "cashback" : ""}`}>{isCashback ? "" : "- "}{userCurrency?.currency}. {convertToRupiah(discount)}</p>
          </div>
        )
      }
      {
        subsidy_price > 0 && (
          <div className="subsidy-price summary-row">
            <p>
              Discount &#40;<span>Automatically applied</span>&#41;
            </p>
            <p>{userCurrency?.currency} {convertToRupiah(subsidy_price)}</p>
          </div>
        )
      }
      {
        totalAddOnProduct > 0 && (
          <div className="promo-product summary-row">
            <p>Promo Product</p>
            <p>{userCurrency?.currency} {convertToRupiah(totalAddOnProduct)}</p>
          </div>
        )
      }
      <div className="total summary-row">
        <p>Amount to be paid</p>
        <p>{userCurrency?.currency} {amountToBePaid}</p>
      </div>
    </div>
  )
}

export default PaymentSummary